import { FormControl, FormHelperText } from "@mui/material";
import FilterLabel from "./FilterLabel";

const FilterController = ({ children, label, error }) => {
  return (
    <FormControl margin="dense" error={!!error} fullWidth>
      <FilterLabel>{label}</FilterLabel>
      {children}
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default FilterController;
